import { Injectable } from "@angular/core";
import { LogLevel, OpenIdConfiguration, StsConfigStaticLoader, OidcSecurityService } from "angular-auth-oidc-client";
import { ALNIdentityAuthService } from "app/core/auth/aln-identity-auth.service";
import { environment as env } from "environments/environment";
import { CookieService } from "ngx-cookie-service";

@Injectable({ providedIn: 'root' })
export class ConfigService {
    private config: OpenIdConfiguration;

    constructor(private _cookieService: CookieService) { }

    getConfig(): OpenIdConfiguration {
        const identity = this._cookieService.get('userIdentity') || 'ALN'; // Default to ALN identity
        const authorityUrl = identity === 'ALN' ? env.AlnIdentity.stsUrl : env.AderantIdentity.stsUrl;
        const clientId = identity === 'ALN' ? env.AlnIdentity.clientId : env.AderantIdentity.clientId;
        const scope = identity === 'ALN' ? env.AlnIdentity.scope : env.AderantIdentity.scope;
        const userEmail = this._cookieService.get('userEmail');
        
        return {
            authority: authorityUrl,
                       redirectUrl: `${window.location.origin}${env.redirectRoute}`,
                       postLoginRoute: this.redirectToUrl(),
                       postLogoutRedirectUri: window.location.origin,
                       clientId: clientId,
                       scope: scope,
                       responseType: 'code',
                       silentRenew: true,
                       silentRenewUrl: `${window.location.origin}/${env.silentRenewRoute}`,
                       logLevel: env.logConsoleDebugActive ? 1 : 0, // Debug/Error
                       disableIatOffsetValidation: true,
                       autoUserInfo: false,
                       customParamsAuthRequest: {
                           loginEmail: userEmail,
                           login_hint: userEmail, // Set login hint as user email
                       }
        };
    }

    async setUserIdentityConfig(identity: string) {
        // Store selected company in localStorage so it's persisted after reload
        this._cookieService.set('userIdentity', identity, 30);
        sessionStorage.setItem('isPreLoginPostBack', "true");
        // Force page reload to apply new OIDC settings
        window.location.reload();
    }

    redirectToUrl(): string {
        const storageKey: string = "currentPostLoginUrl";
        let indexAppgateway: number = window.location.href.indexOf("appgateway");
        let indexSilentRenew: number = window.location.href.indexOf("silent-renew");
        if (indexAppgateway < 0 && indexSilentRenew < 0) {
            var currentUrlPath = window.location.pathname + window.location.search + window.location.hash;
            sessionStorage.setItem(storageKey, currentUrlPath);
        }

        let url: string = sessionStorage.getItem(storageKey) ? sessionStorage.getItem(storageKey) : env.postLoginUrl;

        let adLandingUrlIndex: number = window.location.href.indexOf("autodocket/docket/");
        if (adLandingUrlIndex > 0) {
            sessionStorage.setItem("adLandingPage", JSON.stringify(window.location.pathname));
            url = window.location.pathname;
        }
        const adLandingPagePath = JSON.parse(sessionStorage.getItem("adLandingPage"));
        if (adLandingPagePath && adLandingUrlIndex <= 0) {
            url = JSON.parse(sessionStorage.getItem("adLandingPage"));
            sessionStorage.removeItem('adLandingPage');
        }

        url = this.checkAndReplaceBadUrl(url);
        return url;
    }

    checkAndReplaceBadUrl(url: string): string {
        if (!url || url === "/" || url === "null" || url === "undefined"
            || url.indexOf("silent-renew") > -1
            || url.indexOf("appgateway") > -1 || url.startsWith("/login")) {
            url = env.postLoginUrl;
        }
        return url;
    }
}

export const authFactory = (configService: ConfigService) => {
    const config = configService.getConfig();
    return new StsConfigStaticLoader(config);

};